import React, { Fragment }   from "react";
import { Link } from "react-router-dom";
import { ReactComponent as AudiIcon }   from "../../../assets/images/logo.svg";
import ROUTES from "../../../utils/routes";
import { useHistory } from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { 
    encodeNumber as nToString
}   from "../../../API/request";
import InSearch from "../../InSearch";
import ResultsOverlay from "../ResultsOverlay";
import OverlayMobile from "../OverlayMobile";

const HeaderExtended = ({category,menuType,listado,actual}) => {
    let history = useHistory()

    const goBack = () => {
        history.goBack()
    }

    const getImageMovil = (originalImgUrl) => {
        return originalImgUrl.replace(".jpg","_movil.jpg")
    }

    
    return (
        <Fragment>
            <header className="extended mobile">
                <div className="d-flex">
                    <AudiIcon />
                    <h2 className="ms-3">Audi Collection</h2>
                </div>
            </header>
            <div className="collectionDetails_mobile">
                <OverlayMobile headerExtended={true} />
                <div className="bg-black">
                    <div className="container pe-0">
                        <div className="row collectionDetails_mobile--collection">
                            <div className="col-7 collectionDetails_mobile--collection--info">
                                {
                                    actual !== "Resultados" && <span>Collection</span>
                                }
                                <h4>
                                    { actual }
                                </h4>
                            </div>
                            <div className="col-5 collectionDetails_mobile--collection--image">
                                {
                                    listado.map( (item,i) => 
                                        item.nombre === actual  &&  
                                            <LazyLoadImage
                                                alt={item.img}
                                                src={process.env.REACT_APP_IMAGE_PATH + getImageMovil(item.img)}
                                                key={ "imgMClist_" + i }
                                            />
                                    )
                                }
                                {
                                    actual === "Resultados" &&
                                        <LazyLoadImage
                                            alt={"00188f76-6f1f-453d-834a-40cc5e47088f.jpg"}
                                            src={process.env.REACT_APP_IMAGE_PATH + "00188f76-6f1f-453d-834a-40cc5e47088f.jpg"}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>





            <header className="extended">
                <div className="d-flex">
                    <AudiIcon />
                    <h2 className="ms-3">Audi Collection</h2>

                    <div className="navigation">
                        <Link to={ROUTES.HOME}>Home</Link>
                        {
                            listado.map( (item,i) => 
                                <Link key={ "liClist_" + i } to={ROUTES.COLLECTIONSEMPTY + nToString(item.idCategoria)} className={item.nombre === actual ? "active" : ""}>{item.nombre}</Link>
                            )
                        }
                    </div>
                    
                    <InSearch isMobile={false}/>
                </div>
            </header>
            <ResultsOverlay />
            <div className="collectionDetails row">
                <div className="collectionDetails__info col-9">
                    <button className="btn-general btn-tertiary-prev v-align-c" onClick={goBack}>
                        <svg className="i-rotate" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <path id="arrow_right" d="M10.735,16.028,12,17.293l6-6-6-6L10.735,6.558l3.84,3.84H6v1.789h8.576Z" transform="translate(-6 -5.293)" fill="#fff"/>
                        </svg>
                        <span>Volver</span>
                    </button>

                    {
                        actual !== "Resultados" ? <h3>Collection</h3> : <><br/><br/></>
                    }
                    
                    
                    <span>
                        { actual }
                    </span>

                    {
                        menuType && 
                            <div className="collectionDetails__info--submenu">
                                <div className="v-align-c active"><span>Miniaturas</span></div>
                                <div className="v-align-c"><span>Mens</span></div>
                                <div className="v-align-c"><span>Womens</span></div>
                                <div className="v-align-c"><span>Artículos</span></div>
                            </div>
                    }
                </div>
                <div className="collectionDetails__imagen col-3">
                    {
                        listado.map( (item,i) => 
                            item.nombre === actual  &&   
                                <LazyLoadImage
                                    alt={item.img}
                                    src={process.env.REACT_APP_IMAGE_PATH + item.img}
                                    key={ "imgClist_" + i }
                                />
                        )
                    }
                    {
                        actual === "Resultados" &&
                            <LazyLoadImage
                                alt={"00188f76-6f1f-453d-834a-40cc5e47088f.jpg"}
                                src={process.env.REACT_APP_IMAGE_PATH + "00188f76-6f1f-453d-834a-40cc5e47088f.jpg"}
                            />
                    }
                </div>
            </div>
        </Fragment>
    );
};

export default HeaderExtended;
